import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { CommsSectionSummary } from 'AppSrc/core/components/forms/form-base-components/summary-components/comms-section-summary';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';
import { PostponeAlertModal } from './modals/error-comms-model';

const ViewCommsSummaryDetailed = ({
  openStatuses,
  toggleOpen,
  navigateToSection,
  viewType,
  hasErrors,
  selectedNetwork,
  formData,
  isEmpty,
  isEmptyComms,
  notificationCommsSummaryData,
  notificationCommsSummaryDataDetailed,
}) => {

  // const defaultTab = approvalsContext ? TAB_APPROVALS_HISTORY : TAB_SECTION_SUMMARY;
  // const [openedTab, setTab] = useState(defaultTab);
  const [showError, setShowError] = useState(false);
  const [showComms, setshowComms] = useState('initial');
  const [commsData, setcommsData] = useState([]);

  useEffect(() => {
    if (isEmptyComms === false) {
      setcommsData(notificationCommsSummaryData
        && notificationCommsSummaryData);
      if (notificationCommsSummaryData && notificationCommsSummaryData.comms_info) {
        setshowComms('data');
      }
      if (!notificationCommsSummaryData.comms_info) {
        setshowComms('nodata');
      }
    }
    if ((showComms !== 'data' && showComms !== 'initial') && isEmptyComms === false) {
      setShowError(true);
    }
  }, [showComms, isEmptyComms, commsData, notificationCommsSummaryData]);


  return (
    <div>
      {
        showComms === 'data' && (
          <div className="view-comms-summary-header">
            <div className="width-65">
              Comms type
            </div>
            <div className="width-20">
              Date Sent
            </div>
            <div className="width-10">
              {}
            </div>
          </div>
        )
      }
      <div className="view-crq-section-summary">
        <div className="sections">
          {(!isEmptyComms && showComms === 'data') && (
            commsData.comms_info.map((data, index) => {
              // const formSection = dataByFormSectionId[sectionId];
              const open = openStatuses[index];
              // const notificationTitle = data.comms_category;
              const rawData = data.comms_category;
              const rawDataModified = rawData.split(/[-| ]+/);
              const rawDataFirstValue = rawDataModified[0];
              const rawDataRest = rawDataModified[1].slice(1);
              const rawDataRestFirst = rawDataModified[1].charAt(0);
              const finalValue = rawDataRest.toLowerCase();
              const firstTitle = rawDataFirstValue.concat('-');
              const titleBefore = firstTitle.concat(rawDataRestFirst);
              const notificationTitle = titleBefore.concat(finalValue);
              const notificationDate = data.date_sent;
              const uid = data.global_unique_identifier;
              return (
                <CommsSectionSummary
                  key={data.comms_category}
                  notificationTitle={notificationTitle}
                  notificationDate={notificationDate}
                  uid={uid}
                  open={open}
                  // formSection={formSection}
                  sectionIndex={index}
                  toggleOpen={toggleOpen}
                  navigateToSection={navigateToSection}
                  // sectionErrors={hasErrors ? summaryErrors[sectionId] : null}
                  // summarySectionRead={summarySectionsRead[sectionId]}
                  viewType={viewType}
                  hasErrors={hasErrors}
                  selectedNetwork={selectedNetwork}
                  formData={formData}
                  notificationCommsSummaryDataDetailed={notificationCommsSummaryDataDetailed}
                  isEmpty={isEmpty}
                />
              );
            }))}
          {
            (showError) && (
              <PostponeAlertModal
                closeModal={() => setShowError(false)}
              />
            )
          }
          {
            (!isEmptyComms && showComms === 'nodata' && showError === false) && (
              <div className="error-case">
                <p className="error-case-font">Unable to fetch the comms info details.</p>
                <p className="error-case-font">Please try again later.</p>
              </div>
            )
          }
          {
            isEmptyComms && (
              <div className="view-crq-loader">
                <LoadingSpinner />
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

ViewCommsSummaryDetailed.propTypes = {
  openStatuses: PropTypes.bool,
  toggleOpen: PropTypes.func,
  navigateToSection: PropTypes.func,
  viewType: PropTypes.string,
  hasErrors: PropTypes.bool,
  selectedNetwork: PropTypes.string,
  formData: formDataShape,
  isEmpty: PropTypes.bool,
  isEmptyComms: PropTypes.bool,
  notificationCommsSummaryData: PropTypes.arrayOf(PropTypes.object),
  notificationCommsSummaryDataDetailed: PropTypes.arrayOf(PropTypes.object),
};



export {
  ViewCommsSummaryDetailed,
};
